import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function QueueDisplay() {
  const [data, setData] = useState({ in_progress: null, waiting: [] });
  const [time, setTime] = useState(new Date());
  const [error, setError] = useState(false);

  const fetch = async () => {
    try {
      const res = await axios.get('/api/opd/queue-display');
      setData(res.data || { in_progress: null, waiting: [] });
      setError(false);
    } catch { setError(true); }
  };

  useEffect(() => {
    fetch();
    const dataTimer = setInterval(fetch, 30000);
    const clockTimer = setInterval(() => setTime(new Date()), 1000);
    return () => { clearInterval(dataTimer); clearInterval(clockTimer); };
  }, []);

  const timeStr = time.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  const dateStr = time.toLocaleDateString('en-PK', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div style={{
      minHeight: '100vh', backgroundColor: '#0f172a', color: '#fff',
      fontFamily: "'Segoe UI', Arial, sans-serif", display: 'flex', flexDirection: 'column'
    }}>
      {/* Header */}
      <div style={{ backgroundColor: '#1e293b', padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #334155' }}>
        <div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#38bdf8', letterSpacing: 1 }}>OPD QUEUE</div>
          <div style={{ fontSize: 14, color: '#94a3b8', marginTop: 4 }}>Outpatient Department — Live Display</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 36, fontWeight: 700, color: '#f1f5f9', fontVariantNumeric: 'tabular-nums' }}>{timeStr}</div>
          <div style={{ fontSize: 14, color: '#94a3b8' }}>{dateStr}</div>
        </div>
      </div>

      {error && (
        <div style={{ padding: '16px 40px', backgroundColor: '#7f1d1d', fontSize: 14, color: '#fca5a5', textAlign: 'center' }}>
          Connection error — retrying in 30 seconds...
        </div>
      )}

      <div style={{ flex: 1, display: 'flex', gap: 0 }}>
        {/* Now Serving — large left panel */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 60px', borderRight: '2px solid #1e293b' }}>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 3, marginBottom: 30 }}>Now Serving</div>
          {data.in_progress ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 120, fontWeight: 900, color: '#38bdf8', lineHeight: 1, fontVariantNumeric: 'tabular-nums', textShadow: '0 0 60px rgba(56,189,248,0.4)' }}>
                {data.in_progress.visit_number || data.in_progress.queue_number || '-'}
              </div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#f1f5f9', marginTop: 20 }}>{data.in_progress.patient_name}</div>
              {data.in_progress.doctor && (
                <div style={{ fontSize: 22, color: '#94a3b8', marginTop: 10 }}>Dr. {data.in_progress.doctor}</div>
              )}
              {data.in_progress.department && (
                <div style={{ marginTop: 14, padding: '8px 24px', backgroundColor: '#0284c7', borderRadius: 30, fontSize: 18, fontWeight: 600, display: 'inline-block' }}>
                  {data.in_progress.department}
                </div>
              )}
            </div>
          ) : (
            <div style={{ textAlign: 'center', color: '#475569' }}>
              <div style={{ fontSize: 80 }}>🏥</div>
              <div style={{ fontSize: 24, marginTop: 16 }}>No active consultation</div>
            </div>
          )}
        </div>

        {/* Waiting list — right panel */}
        <div style={{ width: 380, backgroundColor: '#0f172a', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '24px 28px 16px', fontSize: 16, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 2, borderBottom: '1px solid #1e293b' }}>
            Waiting
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {data.waiting.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: '#475569', fontSize: 16 }}>No patients waiting</div>
            ) : data.waiting.slice(0, 8).map((v, i) => (
              <div key={v.id} style={{ padding: '16px 28px', borderBottom: '1px solid #1e293b', display: 'flex', alignItems: 'center', gap: 20,
                backgroundColor: i === 0 ? '#1e3a5f' : 'transparent' }}>
                <div style={{ fontSize: 32, fontWeight: 800, color: i === 0 ? '#38bdf8' : '#475569', minWidth: 56, fontVariantNumeric: 'tabular-nums' }}>
                  {v.visit_number || v.queue_number || '-'}
                </div>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 600, color: i === 0 ? '#f1f5f9' : '#94a3b8' }}>{v.patient_name}</div>
                  {v.doctor && <div style={{ fontSize: 13, color: '#475569' }}>Dr. {v.doctor}</div>}
                </div>
              </div>
            ))}
          </div>
          <div style={{ padding: '16px 28px', borderTop: '1px solid #1e293b', textAlign: 'center', color: '#334155', fontSize: 13 }}>
            Auto-refreshes every 30 seconds
          </div>
        </div>
      </div>
    </div>
  );
}
